// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1XnFz","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3qZB_","gfeWrapper":"CalendarEvent_gfeWrapper__4ezSX"};